import styled from 'styled-components'

export const Ul = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`
